import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=6e49368c&scoped=true"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"
import style0 from "./scroll-pane.vue?vue&type=style&index=0&id=6e49368c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49368c",
  null
  
)

export default component.exports